import React from "react";
import { useAppSelector } from "../../../store/storeHooks";
import { useLocation, useNavigate } from "react-router-dom";

export const PrivacyPolicy = () => {
    return (
        <>
        <div className="contentBox">
            <h2>Terms of Service: Collection and Use of Personal Information</h2>
            <div>
                <span>Fine Digital (“the Company”)</span>
                <p>
                    In the handling of the user's personal information, the Company adheres to the applicable laws and regulations, including the Personal Information Protection Act (“the PIPA”).
                </p>
            </div>
            <ol>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>1</span>
                            Items and Method of Personal Information Collection
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                <strong>① Items of Personal Information for Collection</strong>
                            </p>
                            <div className="tableWrap">
                               <table>
                        <thead>
                            <tr>
                            <th>Collection method</th>
                            <th>Classification</th>
                            <th>Collected information</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td rowSpan={2}>Member registration on website</td>
                            <td>Required</td>
                            <td>Name, ID, password, address, email address, phone number, personal identity verification information, country, date of birth</td>
                            </tr>
                            <tr>
                            <td>Optional</td>
                            <td>
                                English-version website: Vendor, purchase page<br/>
                                Korean-version website: Product model, serial number, phone number, vehicle info
                            </td>
                            </tr>
                            <tr>
                            <td>Member registration on app</td>
                            <td>Required</td>
                            <td>Email address, password, Nickname</td>
                            </tr>
                            <tr>
                            <td rowSpan={2}>Device use</td>
                            <td>Required</td>
                            <td>
                                Smartphone information (OS, screen size, device ID, model name, TID, etc.), service/app usage history, location (GPS) information, speech recognition data, vehicle impact data, app version information, date of consent to terms of service, version of terms of service, consent/non-consent to terms of service, authentication code and generation time, firmware version, Settings data, time data, voltage data, smartphone UUID, IP address, cookies, dates/times of visits, records of malicious use, etc.
                            </td>
                            </tr>
                            <tr>
                            <td>FineVu Cloud / Door cam</td>
                            {/* <td>Required</td> */}
                            <td>Videos and speech (collected videos and speech are accessible to the customer only; members of the Company are unable to access collected videos and speech.)</td>
                            </tr>
                            <tr>
                            <td>MVNO registration</td>
                            <td>Required</td>
                            <td>
                                Name, phone number, DOB/business registration number, corporation registration number, address, method of checking charges, method of payment of charges, USIM info, personal identity verification information (unique identifiable information, country, calling line ID, etc.), credit information (ID number manipulation, illegal spam, voice phishing, other types of phishing, and other grounds for suspension of access of the Services)
                            </td>
                            </tr>
                            <tr>
                            <td>Purchase of products/services and its refund</td>
                            <td>-</td>
                            <td>Bank name, account number, account name, bank card issuer/holder/valid period, CVV code, phone number, email address, proof of Google Play/App Store purchase</td>
                            </tr>
                            <tr>
                            <td>Issue of cash receipts</td>
                            <td>-</td>
                            <td>Mobile phone number, cash receipt ID number, business registration number</td>
                            </tr>
                            <tr>
                            <td>Customer consultation</td>
                            <td>-</td>
                            <td>Name, phone number, address, details of inquiry/complaint, details of communication, vehicle info, product model, serial number</td>
                            </tr>
                            <tr>
                            <td>Order and shipping of products</td>
                            <td>-</td>
                            <td>Buyer's name/phone number/email address, recipient’s name/address/phone number</td>
                            </tr>
                            <tr>
                            <td>Winners of the event</td>
                            <td>-</td>
                            <td>Name, address, phone number, email address, unique identifiable information (In accordance with the Income Tax Act, 22% of the value of a prize in excess of KRW 50,000 is levied as taxes and fees, in which case the prize winner’s unique identifiable information is required.)</td>
                            </tr>
                            <tr>
                            <td>Guest purchases</td>
                            <td>-</td>
                            <td>Buyer's name/phone number/email address, recipient’s name/address/phone number</td>
                            </tr>
                        </tbody>
                        </table>

                            </div>
                            <p>
                                <strong>② Collection Method</strong>
                            </p>
                            <p>
                                The user’s personal information is collected when entered by the user during registration and activity on the website or app, and from written, phone, fax, or email communication with the user. When the user connects to the website or app by a device connected to the internet, personal information linked to said device is automatically collected.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>2</span>
                            Purpose of the Collection and Use of Personal Information
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <div className="tableWrap_2">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Collected personal information</th>
                                            <th>Purpose of Collection and Use</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>ID, password, name, address, email address, phone number, personal identity verification information, country, date of birth</th>
                                            <td>
                                                <p className="borderCircle">Member registration on website</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>English-version website: Vendor, purchase page<br />Korean-version website: Product model, serial number, phone number, vehicle info</th>
                                            <td>
                                                <p className="borderCircle">Entered as optional info at member registration on website</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Email address, password, nickname</th>
                                            <td>
                                                <p className="borderCircle">Member registration on app</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Smartphone information (OS, device ID, model name, TID), service/app use records, location (GPS) information, vehicle impact data, app version information, firmware version, dates/times of visits</th>
                                            <td>
                                                <p className="borderCircle">Service improvement, app function inspection</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Videos and speech (accessible to the customer only)</th>
                                            <td>
                                                <p className="borderCircle">Use of FineVu Cloud and door cams</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, phone number, DOB/business registration number, corporation registration number, address, method of checking charges, method of payment of charges, USIM info, personal identity verification information, credit information</th>
                                            <td>
                                                <p className="borderCircle">Registration with an MVNO</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Parent/guardian’s name, unique identifiable information, email address, phone number</th>
                                            <td>
                                                <p className="borderCircle">A minor’s registration with an MVNO</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Bank name, account number, account name, bank card issuer/holder/valid period, CVV code, phone number, email address, proof of Google Play/App Store purchase</th>
                                            <td>
                                                <p className="borderCircle">Processing of purchases of goods/products</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Mobile phone number, cash receipt ID number, business registration number</th>
                                            <td>
                                                <p className="borderCircle">Issue of cash receipts</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, phone number, address, details of inquiry/complaint, details of communication, vehicle info, product model, serial number</th>
                                            <td>
                                                <p className="borderCircle">Customer consultations</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Buyer's name/phone number/email address, recipient’s name/address/phone number</th>
                                            <td>
                                                <p className="borderCircle">Processing of orders and shipping</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, phone number, address, email address, unique identifiable information</th>
                                            <td>
                                                <p className="borderCircle">Processing of winners of the event, withholding taxes, etc.</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>3</span>
                            Sharing of Personal Information with Third Parties
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                Except in the instances below and in instances where the user’s consent is obtained or applicable laws and regulations exist, the Company does not share personal information with third parties.
                            </p>
                            <div className="tableWrap">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Shared personal information</th>
                                            <th>Purpose of sharing</th>
                                            <th>Third-party receiver</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Name, address, phone number, nationality, unique identifiable information, DOB, electronic serial number, model name, reason for product serial number registration, number of calling lines, registration date, amount in arrears, payer details, subscription status, proof of user account suspension/termination</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Identity theft prevention, settlement of identity theft disputes, prevention of malicious user activities, management of arrears, personal identification of foreign nationals, confirmation of deceased persons’ information, joint management of broadcasting and communication credit information, management of discounted charges, joint response to international voice phishing, joint management of lost terminals, prevention of mobile phone loans, reporting and blocking of spam, other carriers’ confirmation of proof of user account suspension/termination for spam, prevention of re-activation of user accounts suspended for number manipulation, illegal spam, voice phishing, and other types of phishing
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">Korea Association for ICT Promotion</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, unique identifiable information, phone number, proof of user account suspension, address, terminal (model, color, S/N, ESN, MAC ID), USIM info, rate plan, additional services, gender, DOB, mobile phone number, nationality, host MNO of current mobile carrier</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Identity theft prevention, prevention of unfair user activities, joint management of arrears by landline and mobile carriers, access to KT mobile communication networks, billing agency activities, mobile phone ownership verification (personal identification)
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">KT</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, unique identifiable information, phone number</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Name verification, alien status verification, identity verification, credit information check
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">NICE Information Service</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, proof of user account suspension</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Other carriers’ confirmation of proof of user account suspension or termination of authority for illegal spam, subscription restriction, and risk management of high-volume users of mobile phones and users of multiple calling lines
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">SK Telecom, LG U+</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Mobile phone number</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Blocking of SMS from stolen numbers
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">Korea Internet and Security Agency, Daou Technology</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, unique identifiable information, DOB, country, calling line ID, ID issue date, driver’s license number, parent/guardian’s name and unique identifiable information (for minors), proof of departure (for foreign nationals), death certificate</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Identity verification (guardians included), electronic verification of resident registration, proof of departure (for foreign nationals)
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">
                                                    Korea Association for ICT Promotion, Ministry of the Interior and Safety, Ministry of Science and ICT, National Police Agency, Ministry of Justice, Ministry of Health and Welfare, Ministry of Patriots and Veterans Affairs, Office of Court Administration
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Name, unique identifiable information, ID information, address</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Identity theft prevention, notification of service subscription by mail
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">Korea Association for ICT Promotion, other carriers</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>4</span>
                            Commissioned Handling of Personal Information
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company can commission the handling of the user’s personal information by third parties if required to provide improved services or improve user experience. The Company’s partners and their commissioned activities are as follows. If required, partners can be added or changed, in which case the Collection and Use of Personal Information will be updated and the user notified of the update.
                            </p>
                            <div className="tableWrap">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Outsourced handler</th>
                                            <th>Commissioned activities</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Korea Association for ICT Promotion</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Operation of systems for prevention of malicious user activities, information of the user on illegal spammers to minimize spam-related loss and customer protection, communication service subscription information for my-data service, information about payment of charges and use of small purchase service, etc.
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>KT</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Provision of access to KT mobile communication networks, activities related to customer service, billing, and collections agencies, service improvement, provision of additional services offered by KT directly, hardware management of servers where speech recognition data is stored
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>NICE Information Service</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Name verification, alien status verification, identity verification, credit information check
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Korea Financial Telecommunications and Clearings Institute, KG Inicis, NHN KCP</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Automatic bank transfers, credit card payments, account/credit card authentication
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>OFS, Korea Center, AWS Korea</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Website/systems management/maintenance, server management and other hardware management
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Fine Service</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Customer service center operation, handling of customer grievances, information on products/services, after-sale service
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Korea Post, CJ Logistics, Lotte Global Logistics, Kakao Mobility, Samyang Logistics</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Package delivery/pickup service, collection/shipping of items for after-sale service
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Daou Technology</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Advertising SMS from marketing agencies
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Inno Tab</th>
                                            <td>
                                                <p className="borderCircle">
                                                    KakaoTalk notifications
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>B&M Korea, BIS</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Installation of purchased products
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>GS Mbiz</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Distribution of app coupons, VoC response/processing for customer service center
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Newriver, BMC</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Maintenance of website and systems
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>UB1st</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Maintenance of personal/location information systems related to FineVu Connected SK
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>5</span>
                            Overseas Transfer of Personal Information
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                If required for the provision of the Services or the improvement of user experience, the Company can transfer personal information overseas or manage personal information in overseas locations. However, the Company is not transferring personal information overseas at present.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>6</span>
                            Period of Personal Information Storage and Use
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                Personal information collected from the user by the Company is stored and used only for the specified period. However, the Company stores personal information for a set period in instances where such storage is mandated by the applicable laws or regulations or by the Company’s internal policy.
                            </p>
                            <p>
                                <strong>① Instances Where Applicable Laws and Regulations Exist</strong>
                            </p>
                            <div className="tableWrap_3">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Applicable law</th>
                                            <th>Held information</th>
                                            <th>Period of holding</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>Act on the Consumer Protection in Electronic Commerce</th>
                                            <td>
                                                <p className="borderCircle">Records of agreements and subscription withdrawals</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">5 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Act on the Consumer Protection in Electronic Commerce</th>
                                            <td>
                                                <p className="borderCircle">Records of completed payments and supply of goods/services</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">5 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Act on the Consumer Protection in Electronic Commerce</th>
                                            <td>
                                                <p className="borderCircle">Records of consumer grievances and handled disputes</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">3 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Act on the Consumer Protection in Electronic Commerce</th>
                                            <td>
                                                <p className="borderCircle">Records of indications and advertising</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">6 months</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Credit Information Use and Protection Act</th>
                                            <td>
                                                <p className="borderCircle">Records of collection, processing, and use of credit information</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">3 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Electronic Financial Transactions Act</th>
                                            <td>
                                                <p className="borderCircle">Records of electronic financial transactions</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">5 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Protection of Communications Secrets Act</th>
                                            <td>
                                                <p className="borderCircle">
                                                    Dates/times of electronic communication as proof of communication of subscribers, the other party’s subscriber number, parties using electronic communication, records of location tracking of communication devices connected to communication networks
                                                </p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">12 months</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Protection of Communications Secrets Act</th>
                                            <td>
                                                <p className="borderCircle">Logs and IP addresses as proof of communication</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">3 months</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Protection of Communications Secrets Act</th>
                                            <td>
                                                <p className="borderCircle">Records of website visits</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">3 months</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Protection of Communications Secrets Act</th>
                                            <td>
                                                <p className="borderCircle">Proof of communication</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">12 months</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Commercial Act</th>
                                            <td>
                                                <p className="borderCircle">Personal information included in business ledgers and documents</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">10 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Commercial Act</th>
                                            <td>
                                                <p className="borderCircle">Personal information included in slips and similar documents</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">5 years</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>Act on Restriction of Special Taxation</th>
                                            <td>
                                                <p className="borderCircle">Records on cash receipts</p>
                                            </td>
                                            <td>
                                                <p className="borderCircle">1 year</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p>
                                <strong>② Period of Personal Information Storage in Accordance with Company Policy</strong>
                            </p>
                            <ul>
                                <li className="circle">Instances where consent is obtained from individual users: The consented period</li>
                                <li className="circle">Instances of disputes between the Company and the user: Until the conclusion of a dispute</li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>7</span>
                            Procedure and Method of Personal Information Deletion
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company deletes personal information of the user without delay once the purpose of its collection and use has been fulfilled. However, if personal information is to be kept in storage pursuant to regulatory or legal requirements despite the maturation of storage period or the fulfillment of the purpose of personal information handling as consented to by the user, the personal information concerned continues to be stored.
                            </p>
                            <p>
                                <strong>① Deletion Procedure</strong>
                            </p>
                            <p>
                                Personal information that has fulfilled its purpose is stored for a set period for information security purposes in accordance with internal policy and the applicable laws and regulations before deletion.
                            </p>
                            <p>
                                <strong>② Methods of Deletion</strong>
                            </p>
                            <p>
                                Personal information in paper document form is destroyed by shredding or incineration. Personal information in electronic file form is deleted beyond recovery using technology.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>8</span>
                            Rights of the User and the User’s Legal Representative and Their Exercise
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The user and the user’s legal representative can exercise the rights described below in relation to the handling of personal information.
                            </p>
                            <p>
                                <strong>① Rights to the Demand for the Viewing, Correction, and Deletion of Personal Information</strong>
                            </p>
                            <p>
                                The user or a parent/guardian can at any time view and edit the personal information of themselves or a minor under their care, and demand that such personal information be deleted. The user or a parent/guardian can view, edit, or delete personal information themselves, or make a request to the Privacy Policy Officer or other appropriate personnel of the Company in writing or by email, in which case the request will be fulfilled without delay. However, demands for the deletion of personal information cannot be made if the collection of the personal information concerned is stipulated by law. Access to the Services in part or entirety can cease if such personal information is changed or deleted.
                            </p>
                            <p>
                                <strong>② Rights to the Demand for the Cessation of Personal Information Handling</strong>
                            </p>
                            <p>
                                The user or a parent/guardian can at any time request the cessation of the handling of the personal information of themselves or a minor under their care. A request can be made to the Privacy Policy Officer or other appropriate personnel of the Company in writing or by email, in which case the request will be fulfilled without delay. However, the Company can continue to its handling of personal information notwithstanding such a request for cessation if required by the applicable laws and regulations, in which case the user or a parent/guardian will be notified without delay. The user or a parent/guardian can respond to the Privacy Policy Officer or other appropriate personnel of the Company in writing or by email to object to the continued handling of personal information.
                            </p>
                            <p>
                                <strong>③ Rights to the Withdrawal of Consent to the Collection, Use, and Sharing of Personal Information</strong>
                            </p>
                            <p>
                                The user or a parent/guardian can at any time withdraw consent to the collection, use, and sharing of the personal information of themselves or a minor under their care. Accordingly, the user or a parent/guardian can take the steps for user account closure, or a request can be made to the Privacy Policy Officer or other appropriate personnel of the Company in writing or by email, in which case the Company will perform identity verification followed by the appropriate measures, including the deletion of personal information. However, as deleting the app from the user’s smartphone does not delete the personal information collected by the Company, a request for personal information deletion should be made to the Company as indicated.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>9</span>
                            Use of Technology for Automated Collection of Personal Information and Rejection of Said Use
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company uses cookies and other technology to automatically store and retrieve user data as needed to enable first-time users to use the Services provided by the Company. A cookie is a small electronic text file sent to the user’s web browser from a website server to get stored on the hard disk of the user’s PC.
                            </p>
                            <p>
                                <strong>① Data for Automated Collection</strong>
                            </p>
                            <p>
                                Connection logs (including IP addresses), device usage data, service usage data
                            </p>
                            <p>
                                <strong>② Purpose of Automated Collection</strong>
                            </p>
                            <p>
                                Analysis of the customer’s preferences and interests to provide target marketing and improve the Services, provision of personalized services based on purchase history data, provision of information based on customer participation in promotions
                            </p>
                            <p>
                                <strong>③ Rejection of Cookies</strong>
                            </p>
                            <p>
                                The user is entitled to accept or deny the installation of cookies. By setting web browser options, the user can allow all cookies, confirm every saving of cookies, or deny the saving of all cookies. Access to the Services may not be granted if the user rejects the automated collection of the indicated items of personal information.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>10</span>
                            Technological and Administrative Protection of Personal Information
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company employs the following measures in technical and administrative protection of users’ personal information from loss, theft, leakage, alteration, and damage.
                            </p>
                            <p>
                                <strong>① Technological Protection</strong>
                            </p>
                            <ul>
                                <li className="circle">The Company uses one-way encryption to store passwords.</li>
                                <li className="circle">Vaccine programs are used for protection against computer viruses and other security threats. Vaccine programs are regularly updated to prevent breaches of personal information security.</li>
                                <li className="circle">A security system which uses encryption algorithms (SSL) for safe transfer of personal information over networks is used.</li>
                                <li className="circle">The security system is installed in a restricted-access area equipped with anti-intrusion technology to prevent the theft of customers’ personal information by hacking and other malicious activities.</li>
                                <li className="circle">The Company restricts printouts containing personal information and the use of USB drives and other storage devices.</li>
                            </ul>
                            <p>
                                <strong>② Administrative Protection</strong>
                            </p>
                            <ul>
                                <li className="circle">The Company grants access to personal information to a minimal number of personnel.</li>
                                <li className="circle">Every change of personal information handler from a transfer or resignation is promptly followed by the update or termination of access to the personal information handling system.</li>
                                <li className="circle">The Company configures its personal information handling system and the computers used by personal information handlers to prevent exposure of personal information to parties without access permission as a result of website, P2P, or sharing settings.</li>
                                <li className="circle">In instances where personal information is collected, used, or deleted, the Company does so in accordance with the applicable laws and regulations and with internal policy that define the purpose of collection, the period of use, and the deletion of personal information.</li>
                                <li className="circle">The Company puts its personal information handling personnel through frequent training for strict maintenance of personal information security.</li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>11</span>
                            Privacy Policy Officers
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                To protect users’ personal information and process personal information-related complaints, the Company operates the Privacy Policy Officers. The user can forward all inquiries and feedback related to personal information protection arising from the use of the Services provided by the Company to the Privacy Policy Officers to receive a fulsome and prompt response.
                            </p>
                            <ul>
                                <li className="circle">Personal Information Management Department</li>
                                <li className="circle">Chief Privacy Policy Officer: Director Yook Sung-soo</li>
                                <li className="circle">Privacy Policy Officer: Section Chief Song Yoon-ja</li>
                                <li className="circle">Phone: <span>+82 1588-4458</span></li>
                                <li className="circle">Email: <span>privacy@finedigital.com</span></li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>12</span>
                            Processing of Customer Location Information
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company processes personal location information in accordance with the Act on the Protection and Use of Location Information (“the APULI”) as follows. Full details can be found in “Terms of Service: Access to Location Information, and Location-based Services.”
                            </p>
                            <p>
                                <strong>① Purpose of Personal Location Information Handling and Storage Period</strong>
                            </p>
                            <p>
                                The Company stores and uses personal location information for access to location information as required to provide location-based services. Collected location information is stored for six months.
                            </p>
                            <p>
                                <strong>② Purpose and Storage of Proof of the Use/Sharing of Personal Location Information</strong>
                            </p>
                            <p>
                                In accordance with Paragraph 2, Article 16 of the APULI, the Company automatically saves proof of the use or sharing of personal location information, to be held for a period of six months.
                            </p>
                            <p>
                                <strong>③ Procedure and Method of Personal Location Information Deletion</strong>
                            </p>
                            <p>
                                At the end of the set storage period, location information in paper document form is destroyed by shredding or incineration, and location information in electronic file form is deleted beyond recovery using technology.
                            </p>
                            <p>
                                <strong>④ Sharing of Personal Location Information with Third Parties and Its Notification</strong>
                            </p>
                            <p>
                                Before sharing location information with a third party specified by the user, the Company notifies the user of said third party and the date and purpose of location information sharing. However, the Company is not sharing location information with third parties at present.
                            </p>
                            <p>
                                <strong>⑤ Rights and Obligations of Parents/Guardians and Their Exercise</strong>
                            </p>
                            <p>
                                In instances where the parent or guardian of any of the following persons (“child of eight years or younger, etc.”) gives consent to the use or sharing of personal location information regarding the child of eight years or younger, etc. for the protection of the child’s life or physical wellbeing, the Company deems that the child themselves consent thereto:
                            </p>
                            <ul>
                                <li className="circle">A child of eight years old or younger</li>
                                <li className="circle">A person under adult guardianship</li>
                                <li className="circle">
                                    A person with a mental disorder defined in Sub-paragraph 2, Paragraph 2, Article 2 of the Act on Welfare of Persons with Disabilities, classified as a person with a severe disability defined in Sub-paragraph 2, Article 2 of the Act on the Employment Promotion and Vocational Rehabilitation for Persons with Disabilities (limited to those registered as disabled persons under Article 32 of the Act on Welfare of Persons with Disabilities)
                                </li>
                            </ul>
                            <p>
                                A parent or guardian seeking to give consent to the use and sharing of location information for the protection of the life and physical wellbeing of a child of eight years or younger, etc. shall submit to the Company proof of guardianship to the child of eight years or younger, etc.
                            </p>
                            <p>
                                A parent or guardian giving consent to the use and sharing of location information on behalf of a child of eight years or younger, etc. can exercise all location information subject rights of the child of eight years or younger, etc.
                            </p>
                            <p>
                                <strong>⑥ Location Information Officer</strong>
                            </p>
                            <ul>
                                <li className="circle">Chief Location Information Officer: Director Yook Sung-soo</li>
                                <li className="circle">Location Information Protection Officer: Section Chief Jung Tae-wook</li>
                                <li className="circle">Phone: <span>+82 1588-4458</span></li>
                                <li className="circle">Email: <span>privacy@finedigital.com</span></li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>13</span>
                            Remedy for Infringement of User Rights and Interests
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The user can seek assistance with privacy infringements from the agencies listed below. The below agencies are distinct from the Company and are available to provide assistance to users who find the Company’s complaint handling procedures and remedies for infringements unsatisfactory, or who require further assistance.
                            </p>
                            <ul>
                                <li className="circle">Privacy Call Center: <span>www.privacy.kisa.or.kr / 118</span></li>
                                <li className="circle">Cybercrime Investigation Division, Prosecution Service: <span>www.spo.go.kr / 1301</span></li>
                                <li className="circle">Cyber Bureau, National Police Agency: <span>www.spo.go.kr / 182</span></li>
                                <li className="circle">Personal Information Dispute Mediation Committee: <span>www.Kopico.go.kr / 1833-6972</span></li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>14</span>
                            Rejection of Unauthorized Collection of Email Addresses
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company rejects unauthorized collection of any of its email addresses made public by an email address collection program or other such technologies. Infringements are subject to penalties as prescribed by the Act on Promotion of Information and Communications Network Utilization and Data Protection, etc., and other applicable laws or regulations.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>15</span>
                            Serial Number Management of Reported Lost Products
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company contacts the customer without delay when an inquiry about a lost product or an after-sales service request is received. When requested by the police to provide investigative assistance in relation to a lost product, the Company provides such assistance as prescribed by law. However, after two years elapses from the reporting of a lost product, the details of the lost product, including its serial number, are deleted in accordance with Article 250 of the Civil Act.
                            </p>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="titleBox">
                        <p>
                            <span>16</span>
                            Obligations for Disclosure
                        </p>
                    </div>
                    <div className="txtWrap">
                        <div className="txtBox">
                            <p>
                                The Company gives prior notice of any changes to the Collection and Use of Personal Information resulting from changes to applicable laws and regulations, the Company’s internal policy, or security technology standards by one of the following means:
                            </p>
                            <ul>
                                <li className="circle">Notice on the website or app</li>
                                <li className="circle">Email or push (app) notification</li>
                            </ul>
                        </div>
                    </div>
                </li>
            </ol>
            <span>The latest update date: July 15, 2025.</span>
        </div>
        </>
    )
}